export const CUSTOM_MIDDLE_LEFT_CONTROL = 'custom-item-control-ml';
